export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f9d3caf33335601f06d4987f330f3c06418630b54&name=fetchTypeahead!'